const key = 'analytics'
export default key
